import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentFr = () => {
    return (
        <HighlightedText
            text="RÉCLAMEZ VOTRE BONUS bonus de 325% + 400 tours gratuits"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['VOTRE', '325%']}
            breakBeforeWords={['bonus de']}
            className={styles.text_content}
        />
    )
}
